import { render, staticRenderFns } from "./favorite-tool.vue?vue&type=template&id=6cfcb799"
import script from "./favorite-tool.vue?vue&type=script&lang=js"
export * from "./favorite-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports